
import { defineComponent } from "vue";

function buildInitials(displayName: string): string {
  const parts = String(displayName || "")
    .split(/\s+/)
    .filter(Boolean);
  if (!parts.length) {
    return "?";
  }
  return parts
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");
}

export default defineComponent({
  name: "contact-avatar",
  props: {
    profilePhoto: {
      type: String,
      default: ""
    },
    displayName: {
      type: String,
      default: ""
    },
    sizePx: {
      type: Number,
      default: 45
    }
  },
  data() {
    return {
      imageError: false
    };
  },
  computed: {
    sizeClass(): string {
      if (this.sizePx === 45) {
        return "symbol-45px";
      }
      return "";
    },
    sizeStyle(): Record<string, string> | undefined {
      if (this.sizePx === 45) {
        return undefined;
      }
      const px = `${this.sizePx}px`;
      return { width: px, height: px, minWidth: px };
    },
    showImage(): boolean {
      return Boolean(String(this.profilePhoto || "").trim()) && !this.imageError;
    },
    initials(): string {
      return buildInitials(this.displayName);
    },
    altText(): string {
      const name = String(this.displayName || "").trim();
      return name || "Contact";
    }
  },
  watch: {
    profilePhoto() {
      this.imageError = false;
    }
  },
  methods: {
    onImageError() {
      this.imageError = true;
    }
  }
});
